var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioTab2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4V8C9 8.55228 8.55228 9 8 9H4C3.44772 9 3 8.55228 3 8V4Z",
    stroke: "#706F7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 11.4477 3.44772 11 4 11H8C8.55228 11 9 11.4477 9 12V16C9 16.5523 8.55228 17 8 17H4C3.44772 17 3 16.5523 3 16V12Z",
    stroke: "#706F7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C11 3.44772 11.4477 3 12 3H16C16.5523 3 17 3.44772 17 4V8C17 8.55228 16.5523 9 16 9H12C11.4477 9 11 8.55228 11 8V4Z",
    stroke: "#706F7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C11 11.4477 11.4477 11 12 11H16C16.5523 11 17 11.4477 17 12V16C17 16.5523 16.5523 17 16 17H12C11.4477 17 11 16.5523 11 16V12Z",
    stroke: "#706F7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioTab2);
export default __webpack_public_path__ + "static/media/portfolioTab2.a52c119eb0c4f8c3f911f4a0808655ee.svg";
export { ForwardRef as ReactComponent };